import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';
import { LeadService } from 'src/app/private/services/lead.service';
import { LeadActivityService } from 'src/app/private/services/micro-services/leadactivity.service';
import { NoteService } from 'src/app/private/services/micro-services/note.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-add-note',
  imports: [TextareaModule,ButtonModule,FormsModule],
  templateUrl: './add-note.component.html',
  styleUrl: './add-note.component.scss'
})
export class AddNoteComponent {

  @Output() closeDialog = new EventEmitter<any>();
  @Input() isUpdate: boolean = false;
  @Input() title: string = 'Add Note';
  @Input() editLeadData: any;
  @Input() events: any;
  loading = false;
  @Input() lead_id: any;
  @Input() currentLeadId: any;


  constructor(
    private api : LeadService,
    private messageService: MessageService,
    private localStorage: LocalStorageService,
    private route: ActivatedRoute,
    private noteService: NoteService,
    private leadActivityService: LeadActivityService
  ) { 
    
  }

  noteValue = '';

  ngOnChanges() {
    console.log("editLeadData", this.editLeadData);
    if(this.isUpdate && this.editLeadData) {
      this.noteValue = this.editLeadData.desc;
    }
  }



  handleSaveNote() {
    
    const payload: any = {
      "organization_id": this.localStorage.getOrganizationId(),
      "lead_id": this.lead_id,
      "user_id": this.localStorage.getUserId(),
      "note_name": this.noteValue
    }

    this.loading = true;
    
    if(!this.isUpdate){
      this.api.createLeadNote(payload).subscribe({
        next: data => {
          this.loading = false;
          this.noteService.addTask(data);
        this.leadActivityService.getAllLeadTimeLineActivity(this.lead_id);

          this.noteValue = '';
          this.messageService.add({severity:'success', summary: 'Success', detail: 'Note added successfully'});
          this.closeDialog.emit()
        },
        error: error => {
          this.loading = false;
          this.messageService.add({severity:'error', summary: 'Error', detail: 'Failed to add note'});
        }
      }
      )
    }else{
      payload.id = this.editLeadData.id;
      this.api.updateLeadNote(payload).subscribe({
        next: data => {
          this.loading = false;
          this.events = this.events.map((event: any) => {
            if(event.id == this.editLeadData.id) {
              event.desc = this.noteValue;
            }
            return event;
          })
          console.log("events", this.events);
          this.noteService.setTasks(this.events);
          this.noteValue = '';
          this.messageService.add({severity:'success', summary: 'Success', detail: 'Note updated successfully'});
          this.closeDialog.emit()
        },
        error: error => {
          this.loading = false;
          this.messageService.add({severity:'error', summary: 'Error', detail: 'Failed to update note'});
        }
      }
      )
    }
  }

  handleCloseNoteDialog() {
    this.closeDialog.emit()
  }

}
